const assetVersion = "20260529-bracket-v";
const versionedAsset = (path) => `${path}?v=${assetVersion}`;

export const brand = {
  name: "VImplement",
  wordmark: "VImplement",
  tagline: {
    no: "AI, data og operativ software for norske SMB-er.",
    en: "AI, data, and operational software for Norwegian SMBs.",
  },
  logoTagline: "AI, data, software",
  founder: "Victor Berg",
  orgNumber: "934 134 176",
  orgNumberCompact: "934134176",
  location: "Oslo, Norway",
  baseUrl: "https://www.vimplement.com",
  website: "https://www.vimplement.com/no",
  bookingUrl: "https://www.vimplement.com/no/book",
  contact: {
    email: "victor.berg@vimplement.com",
    phoneDisplay: "(+47) 909 22 042",
    phoneCompact: "909 22 042",
    phoneHref: "tel:+4790922042",
    telephone: "+4790922042",
  },
  social: {
    // The LinkedIn company vanity slug intentionally stays "vlimplement": that page
    // is live (linkedin.com/company/vlimplement resolves), while /company/vimplement
    // 404s. Rename the LinkedIn page itself first, then update this value.
    linkedinCompany: "https://www.linkedin.com/company/vlimplement",
    // Founder LinkedIn uses the correct public slug (victor-berg-...); GitHub points to the
    // branded "bergvictor" profile. "vladlevitin" stays a separate infra/Terraform/OIDC account.
    linkedinFounder: "https://www.linkedin.com/in/victor-berg-3ab860150/",
    github: "https://github.com/bergvictor",
  },
  assets: {
    logoPng: versionedAsset("/vimplement-logo-720.png"),
    socialImage: versionedAsset("/social-cover.png"),
  },
};
